<script setup lang="ts">
const open = ref<boolean>(false)

const { activeLocation } = useMapState()!

watch(activeLocation, () => {
  open.value = false
})
</script>

<template>
  <LocationsListSlideover v-model:open="open">
    <UButton>Locaties</UButton>
  </LocationsListSlideover>
</template>
